import Box from 'core-system/Box/Box'
import FlexContainer from 'core-system/FlexContainer'
import CreditCard from 'core-system/Icons/Accounts/CreditCard'
import ColorsPill from 'core-system/Pill/ColorPill'
import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import React from 'react'
import { EmployeeTransitPass } from 'redux/transitPass/transitPassTypes'
import FormattingUtils from 'shared/FormattingUtils'
import styled from 'styled-components'
import {
  formatTransitPassNumber,
  getTransitCardDateLabel,
  getTransitCardStatusColor,
  getTransitCardStatusLabel,
  getTransitCardTitle,
} from './transitCardUtils'

const IconContainer = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.5rem;
  background-color: ${palette.primary.pink200};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

interface MyCommuterTransitCardProps {
  pass: EmployeeTransitPass
}

const MyCommuterTransitCard = React.memo(
  (props: MyCommuterTransitCardProps) => {
    const { pass } = props
    const dateLabel = getTransitCardDateLabel(pass)

    return (
      <Box style={{ padding: '1rem', width: '100%' }}>
        <Text variant='action2' marginBottom='0.75rem'>
          {getTransitCardTitle(pass)}
        </Text>
        <FlexContainer alignItems='center' justifyContent='space-between'>
          <FlexContainer alignItems='center'>
            <IconContainer>
              <CreditCard
                width={20}
                height={20}
                color={palette.primary.pink700}
              />
            </IconContainer>
            <FlexContainer flexDirection='column' marginLeft='0.75rem'>
              <Text variant='action2'>
                {formatTransitPassNumber(pass.transitPassNumber)}
              </Text>
              {dateLabel ? (
                <Text variant='body2' textColor={palette.text.placeholder}>
                  {dateLabel}
                </Text>
              ) : null}
            </FlexContainer>
          </FlexContainer>
          <FlexContainer flexDirection='column' alignItems='flex-end'>
            <ColorsPill
              color={getTransitCardStatusColor(pass.status)}
              text={getTransitCardStatusLabel(pass.status)}
            />
            <Text
              variant='body2'
              textColor={palette.text.placeholder}
              marginTop='0.5rem'
            >
              Balance
            </Text>
            <Text variant='action2'>
              {FormattingUtils.formatDollar(pass.amount || 0, 2)}
            </Text>
          </FlexContainer>
        </FlexContainer>
      </Box>
    )
  }
)

if (process.env.NODE_ENV !== 'production') {
  MyCommuterTransitCard.displayName = 'MyCommuterTransitCard'
}

export default MyCommuterTransitCard
